import axios from 'axios'

export default class TipoAtuacao {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoAtuacao`
    this.tokenBearer = tokenBearer
  }

  getTipoAtuacao () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoAtuacao = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoAtuacao = await axios(optionsTipoAtuacao)
        resolve(responseTipoAtuacao)
      } catch (err) {
        reject(err)
      }
    })
  }
}
